import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const PhotographyReplacement = () => {
  return (
    <>
        <Card className='photography-replacement-container no-border rounded-0 container'>
            <Card className='photography-replacement no-border rounded-0 px-4'>
                <Card.Body>
                    {/* <div className='photography-replacement-title'>Photography Replacement</div> */}
                    <div className='photography-replacement-content text-left no-padding-x'>
                            EC販売では、販売する商品を適切に表示するために、ハイエンドな写真が必要です。
                        <br />
                        <br /> 
                            しかし、これらの写真はスタジオで撮影する必要はなく、バーチャルで作成することができます。3D モデルを使うことで、アングル、色、サイズ、演出など、思い通りのフォトリアリスティックな商品写真を作成することができます。
                        <br />
                        <br /> 
                            例えば、ある家具メーカーを考えてみましょう。ソファやチェア、テーブルなど、あらゆる色やサイズ、バリエーションの製品をスタジオに持ち込んで、さまざまな配置で撮影するとしたら、どれだけの費用がかかるでしょうか。
                            枕やアート作品と一緒に、さまざまなアレンジで写真を撮るとしたら、どれくらいのコストがかかるでしょうか？
                        <br />
                        <br /> 
                            これでは時間とコストがかかり、商品販売するためのネックになる可能性があります。
                        <br />
                        <br /> 
                        フォトグラメトリー（Photogrammetry）に置き換えることで、製品プロモーションのために何百もの画像バリエーションを作成する必要がなくなります。1つのソファーの3Dモデルがあれば、様々な角度から、様々なカラーで、様々な演出で、モックアップを作成することができます。
    
                    </div>
                </Card.Body>
            </Card>
            <CardGroup className='photography-replacement-items no-border rounded-0 px-4'>
                <Card className='no-border rounded-0'>
                    <div className='photography-replacement-items-body-1'>
                    <div className='photography-replacement-items-title'>家具（実物）<br /> （参考写真）</div>
                    </div>
                    <Card.Img className='no-border rounded-0 py-2 photography-replacement-items-image' src={"/assets/photography/chair1.jpg"} />
                </Card>
                <Card className='no-border rounded-0'>
                    <div className='photography-replacement-items-body-2'>
                    <div className='photography-replacement-items-title'>3Dモデル<br /> （アーティスト作成） </div>
                    </div>
                    <Card.Img className='no-border rounded-0 py-2 photography-replacement-items-image1' src={"/assets/photography/chair2.jpg"} />
                </Card>
                <Card className='no-border rounded-0'>
                    <div className='photography-replacement-items-body-3'>
                    <div className='photography-replacement-items-title'> 3Dモデルから <br /> レンダリングしたVRイメージ </div>
                    </div>
                    <Card.Img className='no-border rounded-0 py-2 photography-replacement-items-image2' src={"/assets/photography/chair3.jpg"} />
                </Card>
            </CardGroup>
        </Card>
        <Card className='no-border rounded-0 container'>
            <Card.Title className='fw-bold p-3 mb-4 text-center'>フォトグラメトリー（Photogrammetry）に置き替えるメリット:</Card.Title>
            <Row className='mb-4'>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/p_001.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            ・高精細出力 - 木目や生地の質感を見ることができます。
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/p_002.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            ・管理性の向上 - 出荷の遅れ、天候、人員の問題などで撮影が遅れることがありますが、フォトグラメトリー（Photogrammetry）に置き替えればそのようなことがありません。
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/p_003.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            ・画像のバリエーション-顧客は、白い背景ではなく、リアルな環境で商品を見たいものです。フォトグラメトリーに置き替えることにより、アクセサリーや背景を短期間で追加することができます。
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/p_004.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            ・在庫不要 - 多くのEC企業は、自社のWebサイトチームがいるところに商品を移送しません。フォトグラメトリーに置き替えれば、写真撮影のために商品を再度移動させたり、「使用済み」と表示したりする必要がありません。
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/p_005.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            ・3Dオプション -  3D モデリングによって画像生成をするため、販売者は顧客が製品を購入する前に、製品の3Dビューを提供することができます。
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                
            </Row>
        </Card>
    </>
  )
}

export default PhotographyReplacement
